import React from "react";
import AdvertiserDetails from "./AdvertiserDetails";

// TODO: Do we still need this? Clean up in VTN-35869.
const AdvertiserContent = (props) => {
    return <AdvertiserDetails {...props} />;
};

export default AdvertiserContent;
